import { useAppDispatch, useAppSelector } from "@/shared/lib/redux";
import { useEffect } from "react";
import { fetchApiKey, fetchUserIntegration, selectApiKeyFirstLoad, selectUserIntegrationFirstLoad } from "../model";
import { PageHeader } from "@/widgets/page-header";
import { Integration } from "./integration";
import { ApiKey } from "./api-key";

export const SettingsPage = () => {
    const dispatch = useAppDispatch()
    const apiKeyFirstLoad = useAppSelector(selectApiKeyFirstLoad)
    const userIntegrationFirstLoad = useAppSelector(selectUserIntegrationFirstLoad)

    useEffect(() => {
        if (apiKeyFirstLoad) {
            dispatch(fetchApiKey())
        }
        if (userIntegrationFirstLoad) {
            dispatch(fetchUserIntegration())
        }
    }, [])

    return (
        <div className="_page_container">
            <PageHeader title="настройки" />
            <div className="grid grid-cols-12 gap-4">
                <div className="col-span-6">
                    <ApiKey />
                </div>
                <div className="col-span-6">
                    <Integration />
                </div>
            </div>
        </div>
    )
}